import React from 'react';
import { VIDEOS } from '../mock';

export default function DoubleVideo() {
  return (
    <section className="gradient-bg-light py-16">
      <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-10">
        <div>
          <h3 className="text-center text-[#7a1fb0] font-heading font-extrabold text-2xl md:text-3xl mb-6 underline-purple">CERIMÔNIA NACIONAL</h3>
          <div className="rounded-2xl overflow-hidden shadow-xl bg-black relative" style={{ aspectRatio: '16/9' }}>
            <iframe
              className="w-full h-full absolute inset-0"
              src={`https://www.youtube.com/embed/${VIDEOS.cerimonia}`}
              title="Cerimônia Nacional"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
        <div>
          <h3 className="text-center text-[#7a1fb0] font-heading font-extrabold text-2xl md:text-3xl mb-6 underline-purple">MAIS SOBRE OS BENEFÍCIOS</h3>
          <div className="rounded-2xl overflow-hidden shadow-xl bg-black relative" style={{ aspectRatio: '16/9' }}>
            <iframe
              className="w-full h-full absolute inset-0"
              src={`https://www.youtube.com/embed/${VIDEOS.beneficios}`}
              title="Mais sobre os benefícios"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </section>
  );
}
